import { asyncParagraphType } from '../../components/paragraph-types/async-paragraph-type'
import BrandTeaser from './theme/BrandTeaser.vue'

const ParagraphTypeRecipeSearch = asyncParagraphType('RecipeSearch', {
  deferPreload: true,
  loader: () => import('./theme/ParagraphTypeVueComponent/ParagraphTypeRecipeSearch.vue'),
  hydrateBeforeVisible: true,
  modulePath: 'apps/lecker/theme/ParagraphTypeVueComponent/ParagraphTypeRecipeSearch.vue'
})
const ParagraphTypeLeckerCookbook = asyncParagraphType('LeckerCookbook', {
  loader: () => import('./theme/ParagraphTypeVueComponent/ParagraphTypeLeckerCookbook.vue'),
  modulePath: 'apps/lecker/theme/ParagraphTypeVueComponent/ParagraphTypeLeckerCookbook.vue'
})
const ParagraphTypeLeckerUserProfile = asyncParagraphType('LeckerUserProfile', {
  loader: () => import('./theme/ParagraphTypeVueComponent/ParagraphTypeLeckerUserProfile.vue'),
  modulePath: 'apps/lecker/theme/ParagraphTypeVueComponent/ParagraphTypeLeckerUserProfile.vue'
})
const registerBrandVueComponents = (app) => {
  app.component('ParagraphTypeRecipeSearch', ParagraphTypeRecipeSearch)
  app.component('ParagraphTypeLeckerCookbook', ParagraphTypeLeckerCookbook)
  app.component('ParagraphTypeLeckerUserProfile', ParagraphTypeLeckerUserProfile)
  app.component('BrandTeaser', BrandTeaser)
}

export {
  registerBrandVueComponents
}
